export default "__VITE_ASSET__BNZ9N0uT__"